<script>
  import { Spring } from 'svelte/motion';

  let {
    /** @type {10|15|20|25|30|45|60|75|number} */
    size = 17,
    /** @type {boolean} */
    toggle = false,
    /** @type {number} */
    menu_gap = 5,
    /** @type {string?} */
    color = undefined,
    ...rest
  } = $props();

  const top_line_y = $derived(-menu_gap / 2);
  const bottom_line_y = $derived(menu_gap / 2);

  // define spring configurations
  const spring_config = { stiffness: 0.1, damping: 0.6 };

  // line positions and rotations for each frame
  const frames_1 = $derived([
    { translate_y: top_line_y, rotate: 0 }, // menu state
    { translate_y: 0, rotate: 0 }, // intermediate state
    { translate_y: 0, rotate: 45 }, // close state
  ]);
  const frames_2 = $derived([
    { translate_y: bottom_line_y, rotate: 0 },
    { translate_y: 0, rotate: 0 },
    { translate_y: 0, rotate: -45 },
  ]);

  // svelte-ignore state_referenced_locally (initial spring state is intentional; updates via animate())
  const line1 = new Spring(frames_1[0], spring_config);
  // svelte-ignore state_referenced_locally
  const line2 = new Spring(frames_2[0], spring_config);

  let is_initial_render = true; // Variable to track initial render

  // Derived store to update springs based on toggle state
  $effect(() => {
    animate(toggle);  
    is_initial_render = false;
  });

  // Animate between frames
  function animate() {

    // Prevent animation on initial render
    if(is_initial_render){
      const finalIndex = toggle ? 2 : 0;
      line1.set(frames_1[finalIndex]);
      line2.set(frames_2[finalIndex]);
      return
    }

    // Move to the intermediate state first
    line1.set(frames_1[1]);
    line2.set(frames_2[1]);

    // Then move to the final state after a short delay
    setTimeout(() => {
      const finalIndex = toggle ? 2 : 0;
      line1.set(frames_1[finalIndex]);
      line2.set(frames_2[finalIndex]);
    }, 120); // Delay before proceeding to the final frame

  }
</script>

<svg 
  {...rest}
  aria-label="menu toggle"
  class='button-icon'
  role="presentation"
  style:--icon-color1={color}
  width="{size}" 
  height="{size}"
  viewBox="0 0 15 15"
>
  <g>
    <line 
      x1="0" y1="7.5" x2="15" y2="7.5" 
      style="stroke: currentColor; stroke-width: 1.2; transform: translateY({line1.current.translate_y}px) rotate({line1.current.rotate}deg);" 
    />
    <line 
      x1="0" y1="7.5" x2="15" y2="7.5" 
      style="stroke: currentColor; stroke-width: 1.2; transform: translateY({line2.current.translate_y}px) rotate({line2.current.rotate}deg);" 
    />
  </g>
</svg>


<style lang="postcss">
  svg {
    color: var(--icon-color1, var(--color-default-foreground-300));
    user-select: none;
    object-fit: contain;
    object-position: center;
    transition: all 150ms ease;
  }
  line {
    transform-origin: center;
  }
</style>
